// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingFavoriteButton_root__QYBw3","root_isFavorite":"ListingFavoriteButton_root_isFavorite__RDEUZ","root_link":"ListingFavoriteButton_root_link__9wyn8"};